import React, { FunctionComponent, useState } from 'react';
import type { NotificationSetting, NotificationCategory } from '../../../types/personPreferenceNotificationSettings';

type Props = {
  notificationCategories: NotificationCategory[];
  updatingNotificationIds: number[];
  onToggleChange: (notificationId: number, enabled: boolean) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  notificationCategories = [],  // ← デフォルト値を設定
  updatingNotificationIds,
  onToggleChange,
}) => {
  return (
    <div className="person__show__modal__inner">
      {notificationCategories.length > 0 && notificationCategories.map((category) => (
        <div key={category.category} className="person__show__modal__inner--notification-settings">
          <p className="subtitle">
            {category.category_name}
          </p>
          <ul className='person__show__modal__inner__list notification__settings'>
            {category.notifications.map((notification) => (
              <li key={notification.id}>
                <p className="list__item--title">
                  {notification.name}
                </p>
                <div className="toggle_switch">
                  <input
                    onChange={() => onToggleChange(notification.id, !notification.enabled)}
                    checked={notification.enabled}
                    disabled={updatingNotificationIds.includes(notification.id)}
                    type="checkbox"
                    name={`notification_${notification.id}`}
                    id={`cb_toggle_switch_notification_settings_${notification.id}`}
                  />
                  <label htmlFor={`cb_toggle_switch_notification_settings_${notification.id}`}></label>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};
